var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apuracao-acao-filtro',{on:{"ApuracaoAcaoFiltro__AplicaFiltros":_vm.aplicarFiltros}}),_c('apuracao-acao-lista')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }